import { useState } from "react";
import {
  FaStar,
  FaRegStar,
  FaUserCircle,
  FaThumbsUp,
  FaThumbsDown,
  FaTrash,
  FaBookmark,
  FaRegBookmark
} from "react-icons/fa";
import ProfileModal from "../../ProfileModal";
import { Link } from "react-router-dom";
import ProtectedButton from "../../RBAC/ProtectedButton";


const renderStars = (rating = 0) => {
  const stars = [];
  const filled = Math.round(rating / 2);
  for (let i = 1; i <= 5; i++) {
    stars.push(
      i <= filled ? (
        <FaStar key={i} className="me-1" style={{ color: "#ff9800" }} />
      ) : (
        <FaRegStar key={i} className="me-1" style={{ color: "#ffb74d" }} />
      )
    );
  }
  return stars;
};

export default function SellerCard({
  seller,
  activeTab,
  onBookmark,
  onAccept,
  onReject,
  onRemove,
  onNDA
}) {
  const [isDisabled, setIsDisabled] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [isBookmarked, setIsBookmarked] = useState(seller?.bookmark || false);
  const [isBookmarkLoading, setIsBookmarkLoading] = useState(false);

  const company = seller?.companyId || {};

  const handleBookmark = async (seller) => {
    if (isBookmarkLoading) return; // prevent double click

    try {
      setIsBookmarkLoading(true);

      const prev = isBookmarked;
      setIsBookmarked(!prev);

      await onBookmark?.(seller, !prev);

    } catch (err) {
      // rollback if failed
      setIsBookmarked((prev) => !prev);
    } finally {
      setIsBookmarkLoading(false);
    }
  };


  return (
    <>
      <div className="card shadow-sm rounded-3 mb-3" style={{ backgroundColor: "#FCFCFC" }}>
        <div className="card-body d-flex">
          <div className="d-flex align-items-center justify-content-center px-3">
            <img
              src={company.logo || "/favicon.ico"}
              alt="logo"
              className="rounded-circle flex-shrink-0"
              style={{ width: 70, height: 70, objectFit: "cover" }}
            />
          </div>

          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                  <h6 className="fw-bold mb-0">
                    <button
                      type="button"
                      onClick={() => {
                        setCompanyId(company._id); // or company.companyId
                        setShowProfile(true);
                      }}
                      className="btn btn-link p-0 text-dark fw-bold text-decoration-underline"
                      style={{ lineHeight: "1.2" }}
                    >
                      {company.name || "Unknown Company"}
                    </button>
                  </h6>
                  <span className="fw-semibold ms-1">{company.rating || 0}</span>
                  {renderStars(company.rating)}
                </div>
                <div className="d-flex align-items-center text-secondary" style={{ fontSize: ".9rem" }}>
                  <FaUserCircle className="me-1" />
                  <span>{company.poc || "N/A"}</span>
                </div>
              </div>

              <div className="d-flex align-items-center">
                {activeTab === "sellers" ? (
                  <>
                    <ProtectedButton
                      permission="updateSellerBookmark"
                      className="btn btn-outline-warning btn-sm me-2 btn-icon"
                      disabled={isBookmarkLoading}
                      onClick={() => handleBookmark?.(seller)}
                    >
                      {isBookmarked ? <FaBookmark /> : <FaRegBookmark />}
                    </ProtectedButton>
                    <ProtectedButton
                      permission="updateSellerRequirement"
                      className="btn btn-outline-danger btn-sm me-2 btn-icon"
                      onClick={() => onReject?.(seller)}
                    >
                      <FaThumbsDown />
                    </ProtectedButton>
                    <ProtectedButton
                      permission="updateSellerRequirement"
                      className="btn btn-outline-success btn-sm btn-icon"
                      onClick={() => onAccept?.(seller)}
                    >
                      <FaThumbsUp />
                    </ProtectedButton>
                  </>
                ) : activeTab === "shortlisted" ? (
                  <>
                    <ProtectedButton
                      permission="createAgreement"
                      className="btn btn-sm me-2 btn-icon"
                      style={{ border: "1px solid #181D4C", color: "#181D4C" }}
                      disabled={seller.status === "NDA Initiated" || isDisabled}
                      onClick={() => {
                        setIsDisabled(true);
                        onNDA?.(seller);
                      }}
                    >
                      <img src="/images/nda.svg" alt="nda" />
                      <span className="d-none d-sm-inline">
                        {seller.status === "Buyer Interested" && "Initiate NDA"}
                        {seller.status === "NDA Initiated" && "NDA Initiated"}
                      </span>
                    </ProtectedButton>

                    <button
                      className="btn btn-sm btn-icon"
                      style={{ border: "1px solid red", color: "red" }}
                      onClick={() => onRemove?.(seller)}
                    >
                      <FaTrash />
                    </button>
                  </>
                ) : (
                  <button
                    className="btn btn-sm d-flex align-items-center justify-content-center"
                  >
                    <Link
                      to={`/buyer-dashboard/communication/${seller?.groupChatId}`}
                    >
                      <img
                        src="/images/discussion.svg"
                        alt="Like"
                      />
                    </Link>

                  </button>
                )}
              </div>
            </div>

            <div className="d-flex flex-wrap gap-4 mt-2">
              {/* <div className="metric text-start" style={{ minWidth: "120px" }}>
              <h6 className="fw-bold mb-0">{seller.rate}</h6>
              <small>Hourly Rate</small>
            </div> */}
              <div className="metric text-start" style={{ minWidth: "120px" }}>
                <h6 className="fw-bold mb-0">{company.projects || 0}</h6>
                <small>Projects Completed</small>
              </div>
              {/* <div className="metric text-start" style={{ minWidth: "140px" }}>
              <h6 className="fw-bold mb-0">{seller.completion}</h6>
              <small>On-Time Completion</small>
            </div> */}
              {/* <div className="metric text-start" style={{ minWidth: "160px" }}>
              <h6 className="fw-bold mb-0">{seller.days} days</h6>
              <small>Avg Project Completion</small>
            </div> */}
            </div>

            <div className="mt-2">
              {company?.industry?.map((tag, i) => (
                <span
                  key={i}
                  className="badge bg-light text-dark me-2 mb-2"
                  style={{ fontWeight: 500 }}
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </div>

      </div>
      <ProfileModal
        show={showProfile}
        companyId={companyId}
        onClose={() => setShowProfile(false)}
      />
    </>
  );
}
